import React, { Fragment, useState, FC } from "react";
import {
  Button,
  Dialog,
  Grid,
  IconButton,
  DialogTitle as MuiDialogTitle,
} from "@mui/material";

interface LocationMapProps {
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  button?: string;
  buttonClass?: string;
}

interface CustomDialogTitleProps {
  onClose?: () => void;
}

const DialogTitle: FC<CustomDialogTitleProps> = ({ onClose }) => (
  <MuiDialogTitle>
    {onClose && (
      <IconButton
        className="event-close-btn"
        aria-label="close"
        onClick={onClose}
        size="large"
      >
        <i className="ti-close"></i>
      </IconButton>
    )}
  </MuiDialogTitle>
);

const LocationMap: FC<LocationMapProps> = ({
  maxWidth = "md",
  button = "See Location",
  buttonClass = "",
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  return (
    <Fragment>
      {/* Open Dialog Button */}
      <Button
        className={`btn ${buttonClass}`}
        onClick={handleClickOpen}
        variant="contained"
      >
        {button}
      </Button>

      {/* Modal Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        className="modalWrapper quickview-dialog"
        maxWidth={maxWidth}
      >
        <DialogTitle onClose={handleClose} />
        <Grid className="modalBody modal-body">
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.9147703055!2d-74.11976314309273!3d40.69740344223377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY%2C+USA!5e0!3m2!1sen!2sbd!4v1547528325671"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          ></iframe>
        </Grid>
      </Dialog>
    </Fragment>
  );
};

export default LocationMap;
